import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';


export function SubPageHeader(props) {
  const { t } = useTranslation();
  
  return (
    <div id="container">
      <div className="sub_title">
        <div className="sub_title_txt">
          <span className="depth2">{t(`menu.${props.pageName}`)}</span>
          <span className="desc">EARTHQUAKE RESEARCH INFORMATION</span>
        </div>
      </div>
      <div className="page_nav">
        <div className="container page_location">
          <ul className="menu_list">
            <li className="left home"><Link to="/"><i className="ion ion-md-home"></i></Link></li>
            <li className="left depth1"><Link to={props.categoryUrl}>{t(`menu.${props.categoryName}`)}</Link></li>
            {/* <li className="left depth2"><Link to={props.pageUrl}>{props.pageName}</Link></li> */}
            <li className="left depth2"><a>{t(`menu.${props.pageName}`)}</a></li>
            </ul>
          </div>
      </div>
    </div>
  );
}



